import React, { useContext } from 'react';
import { cx } from "../../../lib/theming/Emotion";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { styles } from "../Modal.styles";
/**
 * Разделитель
 *
 * @visibleName Modal.Separator
 */

export function ModalSeparator(_ref) {
  var fixed = _ref.fixed;
  var theme = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.modalSeparatorWrapper()
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles.modalSeparator(theme), fixed && styles.modalSeparatorFixed())
  }));
}
ModalSeparator.__KONTUR_REACT_UI__ = 'ModalSeparator';
ModalSeparator.displayName = 'ModalSeparator';